module.exports = __webpack_public_path__ + "img/sec3_slide4.be4f6076.jpg";